import React, {ReactNode} from "react";
import {
  IonButtons, IonHeader, IonTitle, IonToolbar,
  IonContent, IonSearchbar, IonList, IonCard,
  IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent,
  IonFab, IonFabButton, IonIcon, IonModal, IonButton,
  IonRefresher, IonRefresherContent, IonProgressBar
} from "@ionic/react";
import { RefresherEventDetail } from '@ionic/core';
import {add} from "ionicons/icons";
import {AppState} from "../models/app";
import {AppDispatch, RootState} from "../global.state";
import {connect} from "react-redux";
import classNames from "classnames";


interface Props {
  app: AppState;
  dispatch: AppDispatch;

  entityLabel: string;
  addEnabled: boolean;
  onClickInstance: (instance: any) => void;
  cardSubTitle: (instance: any) => ReactNode;
  cardTitle: (instance: any) => ReactNode;
  cardContent: (instance: any) => ReactNode;
  ModelForm: any;
  modelFormProps?: any;
  colecao: any[];
  loading: boolean;
  filtrarColecao: (criterio:string) => void;

  criterio?: string;
  modalNoPadding?: boolean;
}

interface State {
  modelFormVisible: boolean;
  modelFormKey: string;
  criterio: string;
}

class _EntityList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      modelFormVisible: false,
      modelFormKey: Math.random().toString(),
      criterio: props.criterio !== undefined ? props.criterio : '',
    };
  }

  public static defaultProps = {
    modelFormProps: {},
  };

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (this.props.criterio !== undefined && this.props.criterio !== prevProps.criterio) {
      this.setState({criterio: this.props.criterio})
    }
  }

  doRefresh = (event: CustomEvent<RefresherEventDetail>) => {
    event.detail.complete();
  };

  onClickAdd = () => {
    this.setState({
      modelFormVisible: true,
      modelFormKey: Math.random().toString(),
    });
  };

  onCloseForm = () => {
    this.setState({modelFormVisible: false});
  };

  onSubmitForm = () => {
    this.setState({modelFormVisible: false});
  };

  onSearch = (e:any) => {
    const criterio = e.target.value;
    this.setState({criterio}, () => this.props.filtrarColecao(criterio));
  };

  render() {
    const {ModelForm} = this.props;

    return (
      <>
        <IonRefresher slot="fixed" onIonRefresh={this.doRefresh}>
          <IonRefresherContent/>
        </IonRefresher>

        <IonSearchbar
          onIonChange={this.onSearch}
          value={this.state.criterio}
        />

        {
          !this.props.app.notification.visible && this.props.addEnabled &&
          <IonFab
            vertical="bottom"
            horizontal="end"
            slot="fixed"
          >
            <IonFabButton onClick={this.onClickAdd} color="secondary">
              <IonIcon icon={add}/>
            </IonFabButton>
          </IonFab>
        }

        {
          this.props.loading &&
            <IonProgressBar type="indeterminate"/>
        }

        <IonList>
          {
            this.props.colecao.map(i => (
              <IonCard
                key={i.id}
                button={true}
                onClick={() => this.props.onClickInstance(i)}
                color="tertiary"
              >
                <IonCardHeader>
                  <IonCardSubtitle>
                    {this.props.cardSubTitle(i)}
                  </IonCardSubtitle>
                  <IonCardTitle>
                    {this.props.cardTitle(i)}
                  </IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  {this.props.cardContent(i)}
                </IonCardContent>
              </IonCard>
            ))
          }
        </IonList>

        <IonModal
          isOpen={this.state.modelFormVisible}
          onDidDismiss={this.onCloseForm}
        >
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="primary">
                <IonButton onClick={this.onCloseForm}>
                  Cancelar
                </IonButton>
              </IonButtons>
              <IonTitle>
                Adicionar {this.props.entityLabel}
              </IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonContent
            className={classNames({'ion-padding': !this.props.modalNoPadding})}
          >
            <ModelForm
              key={this.state.modelFormKey}
              onSubmit={this.onSubmitForm}
              {...this.props.modelFormProps}
            />
          </IonContent>
        </IonModal>
      </>
  );
  }
}

export const EntityList = connect(({app}: RootState) => ({app}))(_EntityList);
